/**
* webview环境检查
* @return Object
*/

const ua = navigator.userAgent.toLowerCase();
const screen = window.screen;
const screenWidth = screen.width;
const screenHeight = screen.height;

// X/XS
const isIphoneX = /iphone/gi.test(ua) && screenWidth === 375 && screenHeight === 812;
// XS Max
const isIphoneXsMax = /iphone/gi.test(ua) && screenWidth === 414 && screenHeight === 896;
// XR
const isIphoneXR = /iphone/gi.test(ua) && screenWidth === 414 && screenHeight === 896;
// iPad
const isIpad = /ipad/gi.test(ua);
// 安卓平板
const isAndroidTable = /android/gi.test(ua) && !(/mobile/gi.test(ua));

const webview = {
  isIpad,
  isAndroidTable,
  isApple: /iphone|ipad|ios|mac/gi.test(ua),
  isTablet: isIpad || isAndroidTable,
  isIphone: /iphone/gi.test(ua),
  iphoneXSet: isIphoneX || isIphoneXsMax || isIphoneXR,
  isWeixin: /micromessenger/gi.test(ua),
  isQQ: /qq(?!browser)/gi.test(ua), // 区分x5内核
  isWeibo: /weibo/gi.test(ua),
  isKuaikan: /kuaikan/gi.test(ua),
  isAndroid: /android/gi.test(ua)
};

export default webview;